import { useState } from 'react';
import './PDFReader.scss';
import { Document, Page } from 'react-pdf';
import { Carousel } from 'react-bootstrap';

interface docProps {
  numPages?: number;
}

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true
};

interface PDFReaderProps {
  filePath: string;
}

function PDFReader({ filePath }: PDFReaderProps) {
  const [numPages, setNumPages] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(0);

  function onDocumentLoadSuccess({ numPages }: docProps) {
    setNumPages(numPages);
  }

  const handleSelect = (selectedIndex: number, e: any) => {
    setPageNumber(selectedIndex);
  };

  const getWidth = () => {
    const maxWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
    return maxWidth > 1300 ? 1300 : maxWidth;
  };

  return (
    <>
      <div className="container-document">
        <Document file={filePath} onLoadSuccess={onDocumentLoadSuccess} options={options} className="pdf-document">
          <Carousel activeIndex={pageNumber} onSelect={handleSelect} className="carousel-slider" slide={true} interval={null}>
            {Array.from(new Array(numPages), (el, index) => (
              <Carousel.Item key={`img-carousel-${index}`}>
                <Page key={`page_${index + 1}`} pageNumber={index + 1 || 1} width={getWidth() * 0.9} />
              </Carousel.Item>
            ))}
          </Carousel>
        </Document>
      </div>
    </>
  );
}

export default PDFReader;
